import Form from "@/components/ai/test/Form.vue";
import List from "@/components/ai/test/List.vue";

export const ai = [
    {path: '/ai/test', name: 'ai', component: Form},
    {path: '/ai/test-list', name: 'aiList', component: List},
]